import { render, staticRenderFns } from "./LpuLicenseBadge.vue?vue&type=template&id=794f1b52&scoped=true&"
import script from "./LpuLicenseBadge.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LpuLicenseBadge.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./LpuLicenseBadge.vue?vue&type=style&index=0&id=794f1b52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794f1b52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('794f1b52')) {
      api.createRecord('794f1b52', component.options)
    } else {
      api.reload('794f1b52', component.options)
    }
    module.hot.accept("./LpuLicenseBadge.vue?vue&type=template&id=794f1b52&scoped=true&", function () {
      api.rerender('794f1b52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/diagnostika/analiz/components/LpuLicenseBadge.vue"
export default component.exports